import axios from "axios";
import { Partner_Service_URL } from "../Url";
import HashMap from "hashmap";
import { Form, Select, Drawer, message } from "antd";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
export const saveChangeSignatoryAction = {
  SAVE_CHANGE_SIGNATORY_DETAILS_SUCCESS:
    "SAVE_CHANGE_SIGNATORY_DETAILS_SUCCESS",
  SAVE_CHANGE_SIGNATORY_DETAILS_ERROR: "SAVE_CHANGE_SIGNATORY_DETAILS_ERROR",
};

export function saveChangeSignatoryDetail(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/saveSignatoryDetails?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveChangeSignatorySuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveChangeSignatoryError(error));

          return response;
          throw error;
        }
      })
      .catch((err) => {
        // message.error(err.response.data.error.message);

        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function saveChangeSignatoryError(error) {
  return {
    type: saveChangeSignatoryAction.SAVE_CHANGE_SIGNATORY_DETAILS_ERROR,
    payload: error,
  };
}

export function saveChangeSignatorySuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveChangeSignatoryAction.SAVE_CHANGE_SIGNATORY_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const getChangeSignatoryAction = {
  GET_CHANGE_SIGNATORY_DETAILS_SUCCESS: "GET_CHANGE_SIGNATORY_DETAILS_SUCCESS",
  GET_CHANGE_SIGNATORY_DETAILS_ERROR: "GET_CHANGE_SIGNATORY_DETAILS_ERROR",
};

export function getChangeSignatoryDetail(props) {
  const { access_token, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getSingatoryDetails?partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getChangeSignatoryDetailSuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getChangeSignatoryDetailError(error));

          return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function getChangeSignatoryDetailError(error) {
  return {
    type: getChangeSignatoryAction.GET_CHANGE_SIGNATORY_DETAILS_ERROR,
    payload: error,
  };
}

export function getChangeSignatoryDetailSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getChangeSignatoryAction.GET_CHANGE_SIGNATORY_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
